import { useKpiTracker, useSession } from "@pocketrocketgmbh/kpi-tracker";

const config = {
  gameId: process.env.VUE_APP_GAME_ID || "",
  apiUrl: process.env.VUE_APP_API_URL || "",
  apiUsername: process.env.VUE_APP_API_USERNAME,
  apiPassword: process.env.VUE_APP_API_PASSWORD,
};

// Singleton-Instanzen
let kpiTrackerInstance = null;
let sessionInstance = null;

export function useGameTracking() {
  // Erstelle Singleton-Instanzen nur einmal
  if (!kpiTrackerInstance || !sessionInstance) {
    // initialTimesLeftToPlay: Anzahl der Spiele, die ein Spieler spielen kann
    // Passe diesen Wert an dein Spiel an (z.B. 1 = Spieler kann 1x spielen)
    kpiTrackerInstance = useKpiTracker(1);
    sessionInstance = useSession(config, kpiTrackerInstance);
  }

  return {
    kpiTracker: kpiTrackerInstance,
    session: sessionInstance,
  };
}

